import { createApp } from 'vue'
import App from './App.vue'
import './style.css'
import i18n from './i18n'
import router from './router'

const app = createApp(App)

// 设置页面标题
function setPageTitle() {
  document.title = i18n.global.t('common.pageTitle')
}

// 初始设置
setPageTitle()

// 监听语言变化
import { watch } from 'vue'
watch(
  () => i18n.global.locale.value,
  () => {
    setPageTitle()
  }
)

app.use(router).use(i18n).mount('#app')
